import { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import { ProviderContext } from '../Provider'
import { checkoutSteps } from '../utils/steps'

const useStepNavigation = () => {
  const {
    state: {
      obdFit,
      difficultPlugginConfirmed,
      isTrackerless,
      shouldShowExtrasPopUp,
      confirmPageButtons,
      confirmPageErrors,
      currentLocation,
    },
    handleShowModal,
    simpleStateUpdater,
    handleSetConfirmPageErrors,
  } = useContext(ProviderContext)
  const history = useHistory()

  const validateCheckoutNavigation = (target: string, currentStepIndex: number) => {
    const targetStepIndex = checkoutSteps.findIndex((step: string) => step.includes(target))

    if (targetStepIndex < currentStepIndex) {
      if (currentLocation === '/how') {
        handleSetConfirmPageErrors({ ...confirmPageErrors, stickyError: false })
      }
      history.push(target)
      return true
    }

    if (currentLocation === '/cover' && shouldShowExtrasPopUp) {
      simpleStateUpdater([
        { state: 'showModal', value: true },
        { state: 'activeModal', value: 'extras-popup' },
        { state: 'extrasPopupSeen', value: true },
      ])
      return false
    }

    if (
      currentLocation === '/how' &&
      (obdFit === 'YesWithCheck' || obdFit === 'YesWithCheckWithCable') &&
      !difficultPlugginConfirmed &&
      !isTrackerless
    ) {
      handleShowModal('difficult-plugin')
      return false
    }

    if (currentLocation === '/confirm' && (!confirmPageButtons.policyList || !confirmPageButtons.trackerActivation)) {
      handleSetConfirmPageErrors({
        policyList: !confirmPageButtons.policyList,
        trackerActivation: !confirmPageButtons.trackerActivation,
        stickyError: true,
      })
      const element = document.querySelector('button.accept-button')
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
      return false
    }

    history.push(target)
    return true
  }

  return {
    validateCheckoutNavigation,
  }
}

export default useStepNavigation
